import {
  FormElementConditionType,
  FormElementEventTrigger,
  FormElementEventType,
  FormResponseStatus,
  FormRuleType,
  LoginAccountRuleType,
  StatusBasedConditionType,
  TimeFrameRuleType,
  WorkflowEventTriggerType,
  WorkflowStatusChangeActionType,
} from "~/api";

export type EnumDisplayNames<T extends number | string> = {
  [K in T]: K extends T ? string : never;
};

export const conditionDisplayNames: EnumDisplayNames<FormElementConditionType> =
  {
    [FormElementConditionType.ANSWER_EQUALS]: "=",
    [FormElementConditionType.ANSWER_NOT_EQUALS]: "≠",
    [FormElementConditionType.ANSWER_CONTAINS]: "Contains",
    [FormElementConditionType.ANSWER_NOT_CONTAINS]: "Doesn't Contain",
    [FormElementConditionType.ANSWER_HAS_ANY_VALUE]: "Has Any Value",
    [FormElementConditionType.ANSWER_HAS_NO_VALUE]: "Has No Value",
    [FormElementConditionType.COUNT_EQUALS]: "File Count =",
    [FormElementConditionType.COUNT_NOT_EQUALS]: "File Count ≠",
  };

export const statusConditionDisplayNames: EnumDisplayNames<StatusBasedConditionType> =
  {
    [StatusBasedConditionType.STATUS_IS]: "Status Is",
    [StatusBasedConditionType.STATUS_IS_NOT]: "Status Is not",
    [StatusBasedConditionType.STATUS_IS_AFTER]: "Status Is After",
    [StatusBasedConditionType.STATUS_IS_BEFORE]: "Status Is Before",
  };

export const loginAccountConditionDisplayNames: EnumDisplayNames<LoginAccountRuleType> =
  {
    [LoginAccountRuleType.USER_BELONGS_TO]: "Belongs To",
    [LoginAccountRuleType.USER_DOES_NOT_BELONG_TO]: "Does Not Belong To",
  };

export const timeFrameConditionDisplayNames: EnumDisplayNames<TimeFrameRuleType> =
  {
    [TimeFrameRuleType.WITHIN_TIME_FRAME]: "Within",
    [TimeFrameRuleType.NOT_WITHIN_TIME_FRAME]: "Not Within",
  };

export const formResponseStatusDisplayNames: EnumDisplayNames<FormResponseStatus> =
  {
    [FormResponseStatus.NEW]: "New",
    [FormResponseStatus.DRAFT]: "Draft",
    [FormResponseStatus.NOT_SENT]: "Not Sent",
    [FormResponseStatus.READY_FOR_SUBMISSION]: "Ready For Submission",
    [FormResponseStatus.SUBMITTED]: "Submitted",
  };

export const sectionRuleTypeDisplayNames: EnumDisplayNames<FormRuleType> = {
  [FormRuleType.IS_RESTRICTED_TO]: "Access",
  [FormRuleType.REQUIRES_APPROVAL]: "Approvals",
  [FormRuleType.REQUIRES_REVIEW]: "Reviews",
};

export const formElementEventTriggerDisplayNames: EnumDisplayNames<FormElementEventTrigger> =
  {
    [FormElementEventTrigger.ON_SAVE]: "On Save",
  };
export const formElementEventTypeDisplayNames: EnumDisplayNames<FormElementEventType> =
  {
    [FormElementEventType.SUM_TO]: "Sum Of",
    [FormElementEventType.PERCENTAGE_TO]: "Percentage Of",
    [FormElementEventType.CUSTOM_EXPRESSION]: "Custom Expression",
  };

export const workflowStatusChangeActionDisplayNames: EnumDisplayNames<WorkflowStatusChangeActionType> =
  {
    [WorkflowStatusChangeActionType.SEND_EMAIL]: "Send Email",
    [WorkflowStatusChangeActionType.OTHER]: "Other",
    [WorkflowStatusChangeActionType.CREATE_FOLLOW_UP_WORKFLOW]:
      "Create Follow-Up Workflow",
  };

export const workflowEventTriggerTypeDisplayNames: EnumDisplayNames<WorkflowEventTriggerType> =
  {
    [WorkflowEventTriggerType.STATUS_CHANGE]: "Status Change",
    [WorkflowEventTriggerType.ACTION_CODE]: "Action Code",
    [WorkflowEventTriggerType.OTHER]: "Other",
  };
